import * as yup from 'yup';

export const formValidationSchema = yup.object().shape({
  vehicle: yup.object().shape({
    km: yup.string().test('is-km-valid', function (value) {
      const { lastKm } = this.parent;
      if (!value || !lastKm) return true;

      const kmNumber = parseFloat(value.replace('.', '').replace(',', '.'));
      const lastKmNumber = parseFloat(
        lastKm.replace('.', '').replace(',', '.'),
      );

      if (kmNumber < lastKmNumber) {
        return this.createError({
          path: 'vehicle.km',
          message: `O KM deve ser maior ou igual ao último KM (${lastKm}).`,
        });
      }

      return true;
    }),
    lastKm: yup.string(),
    plate: yup
      .string()
      .notRequired()
      .test('valid-plate', 'Placa inválida', value => {
        if (!value) return true;
        return /^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(value);
      }),
  }),
  customer: yup.object().shape({
    name: yup.string().required('informe um nome'),
    phone: yup
      .string()
      .required('informe um telefone')
      .min(10, 'informe um telefone válido'),
  }),
});
